import { Loader2 } from 'lucide-react'
import { cn } from '../../lib/utils'

interface SpinLoaderProps {
  size?: 'sm' | 'md' | 'lg'
  label?: string
  className?: string
}

const sizeMap = {
  sm: 'h-5 w-5',
  md: 'h-8 w-8',
  lg: 'h-12 w-12',
}

export function SpinLoader({ size = 'md', label, className }: SpinLoaderProps) {
  return (
    <div className={cn('flex items-center justify-center py-12', className)}>
      <Loader2 className={cn('animate-spin text-primary', sizeMap[size])} />
      {label && <span className="ml-3 text-text-secondary">{label}</span>}
    </div>
  )
}
